// 为中文
export const checkChinese = (value) => {
    const chineseReg = /^[\u4e00-\u9fa5]{0,}$/;
    return value ? chineseReg.test(value) : true;

}
// 手机号
export const checkPhone = (value) => {
    const phoneReg = /^(?:13\d|14\d|15\d|16\d|17\d|18\d|19\d)\d{5}(\d{3}|\*{3})$/;
    return value ? phoneReg.test(value) : true;
}